// extracted by mini-css-extract-plugin
export default {"report_div_wrap":"style_report_div_wrap__Y4+qo","report_div_con":"style_report_div_con__NQAFO"};